<template>
  <div class="home">
    <el-header class="navbar">
      <commonHeader/>
    </el-header>
    <el-main class="main-content">
      <router-view/>
    </el-main>

    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-top">
            <div class="footer-left">
              <div class="qr-item">
            <img class="qr-img" src="../assets/index/jszc_qr.png" alt="技术支持二维码"/>
            <div class="qr-caption">技术支持</div>
          </div>
              <div class="qr-item">
            <img class="qr-img" src="../assets/index/swhz_qr.png" alt="商务合作二维码"/>
            <div class="qr-caption">商务合作</div>
          </div>
            </div>
            <div class="footer-right">
              <img alt="b_yb_logo" class="b_yb_logo" src="../assets/index/db_logo.png">
            </div>


          </div>
          <div class="footer-bottom">
            <div class="footer-left">
              <router-link to="/privacy" class="footer-link">隐私条款</router-link>
              <router-link to="/risk" class="footer-link">风险提示</router-link>
              <router-link to="/disclaimer" class="footer-link">免责条款</router-link>
            </div>
            <div class="footer-right">
              <p class="copyright">
                Copyright&nbsp;&nbsp;©&nbsp;&nbsp;2025&nbsp;&nbsp;悦宝金服-上海悦宝互联网金融信息服务股份有限公司</p>
              <p class="disclaimer">本网站不提供任何投资咨询服务、投资顾问服务、投资理财服务</p>
              <p class="copyright"><a href="https://beian.miit.gov.cn/"
                                      style="text-decoration: none;color: inherit"
                                      target="_blank">沪ICP备17003327号-1</a></p>

            </div>
          </div>
        </div>
      </div>
    </footer>


  </div>

</template>

<script>
import CommonAside from "@/components/Aside.vue";
import CommonTab from "@/components/Tab.vue";
import CommonHeader from "@/components/Header.vue";
import {getCurrentInstance} from "vue";

export default {
  name: "Layout",
  components: {
    CommonAside,
    CommonHeader,
    CommonTab,
  },
  data() {
    return {
      zx_qr_show: false,
      conf: {
        version: getCurrentInstance()?.appContext.config.globalProperties
            .$g_version,
      },
    };
  },
  methods: {
    zxMouseOver() {
      this.zx_qr_show = true;
    },
    zxMouseOut() {
      this.zx_qr_show = false;
    },
    to_ystk() {
      this.$router.push("/privacy");
    },
    to_fxts() {
      this.$router.push("/risk");
    }
  }
};
</script>
<style lang="scss" scoped>
.home {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #F7F7F7;
}
.navbar {
  height: 78px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.el-header {
  --el-header-padding: 0 0;
  --el-header-height: 3.5vh;
  width: 100%;
  background-color: #fff;
  height: 78px;
  //border-bottom: 2px solid #C5C5C5;
  padding: 0 15%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .1);
  z-index: 1000;
  display: flex;
  align-items: center;
}

.el-container {
  background-color: #f2f4f6;
  width: 100%;
  height: 100%;
}

.main-content {
  flex: 1;
  min-height: calc(100vh - 98px - 248px); /* 减去导航栏和页脚的高度 */
  padding: unset;
}

.container-main {
  padding: unset;
  background-color: #F5F5F5;
  /*background-image: url(../assets/index/syjy.png);*/
  overflow: unset;
  position: relative;
}

.el-container {
  width: 100%;
  overflow-x: hidden;
}

.bottom-title {
  padding-top: 10px;
  margin-top: 10px;
  font-size: 0.3rem;
  color: #C6C5BF;
  text-align: center;
  /*margin-bottom: 20px;*/
  background-color: #06103F;
  padding-bottom: 15px;
  /*position: absolute;*/
  /*bottom: 0;*/
  width: 100%;
}

.zx_mr_box {
  position: fixed;
  right: 40px;
  bottom: 200px;
  font-size: 100px;
  background-image: url(../assets/index/zx-mr.png);
  background-size: 100% 100%;
  width: 54px;
  height: 54px;
}

.zx_xf_box {
  position: fixed;
  right: 40px;
  bottom: 200px;
  font-size: 100px;
  background-image: url(../assets/index/zx-xf.png);
  background-size: 100% 100%;
  width: 54px;
  height: 54px;
}

.zx_qr_box {
  position: fixed;
  right: 120px;
  bottom: 150px;
  width: 100px;
  height: 120px;
  border: 10px solid white;
  background-color: white;
  color: #7E7E7E;

}

/* 底部区域 */
.bottom-section {
  height: 200px;
  background-color: #040404;

}

.bottom-row {
  height: 50%;
}

.bottom-right-cell {
  width: 40%;
  float: right;
  padding-right: 250px;
  text-align: right;
}

.bottom-left-cell {
  width: 30%;
  float: left;
  padding-left: 250px;
  line-height: 0;
}


.bottom-logo {
  height: 40px;
  width: auto;
  margin-top: 20px;
}

.privacy-link,
.risk-link {
  color: #FFFFFF;
  font-size: 14px;
  cursor: pointer;
  margin-right: 30px;
  line-height: 0;
}

.privacy-link:last-child,
.risk-link:last-child {
  margin-right: 0;
}

.privacy-link:hover,
.risk-link:hover {
  text-decoration: underline;
}

.copyright-text {
  color: #FFFFFF;
  font-size: 12px;
  margin-bottom: 10px;
  text-align: right;
  line-height: 1;
}

.disclaimer-text {
  color: #FFFFFF;
  font-size: 12px;
  margin-bottom: 10px;
  text-align: right;
}


.footer {
  background-color: #000;
  padding: 30px 0;
  display: flex;
  align-items: center;
}

.footer .container {
  max-width: 100%;
  margin: 0 auto;
  padding: 0 15%;
  width: 100%;
}

.footer-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.footer-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

}

.footer-divider {
  height: 1px;
  background-color: #fff;
  opacity: 0.1;
  margin-bottom: 20px;
  margin-top: 35px;
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  //align-items: flex-start;
  align-items: unset;
}

.footer-left {
  display: flex;
  gap: 30px;
  align-items: flex-end;
}

.footer-link {
  color: #999;
  text-decoration: none;
  font-size: 12px;
  transition: color 0.3s;
}

.footer-link:hover {
  color: #C52133;
}

.footer-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.b_yb_logo {
  height: 32px;
  width: 180px;
  padding-bottom: 20px;

}

.copyright, .disclaimer {
  color: #999;
  font-size: 12px;
  margin: 0;
  line-height: 1.6;
}

.qr-item {
  text-align: center;
}

.qr-img {
  width: 60px;
  height: 60px;
  object-fit: contain;
}

.qr-caption {
  color: #999;
  font-size: 12px;
  position: absolute;
  width: 60px
}

/* 响应式媒体查询 */
@media (max-width: 1200px) {
  .el-header {
    padding: 0 5%;
  }

  .footer .container {
    padding: 0 5%;
  }
}

@media (max-width: 768px) {
  .b_yb_logo {
    height: 25px;
    width: 120px;

  }
  .el-header {
    height: auto;
    min-height: 78px;
    padding: 10px 5%;
  }

  .main-content {
    min-height: calc(100vh - 120px - 200px); /* 调整最小高度计算 */
  }

  .footer {
    padding: 20px 0;
  }

  .footer .container {
    padding: 0 5%;
  }

  .footer-top {
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }

  .footer-bottom {
    flex-direction: column;
    gap: 15px;
    align-items: center;
    text-align: center;
  }

  .footer-left {
    justify-content: center;
  }

  .footer-right {
    align-items: center;
  }

  .qr-item {
    margin: 5px 10px;
  }
}

@media (max-width: 480px) {
  .b_yb_logo {
    height: 20px;
    width: 100px;

  }
  .el-header {
    padding: 8px 3%;
  }

  .footer .container {
    padding: 0 3%;
  }

  .footer-left {
    gap: 10px;
  }

  .footer-link {
    font-size: 11px;
  }

  .copyright, .disclaimer {
    font-size: 11px;
  }

  .qr-img {
    width: 50px;
    height: 50px;
  }

  .qr-caption {
    width: 50px;
    font-size: 10px;
  }
}

</style>
<style>
  @media (max-width: 768px) {
    .el-message{
      min-width: 200px !important;
    }

  }
  @media (max-width: 480px) {
    .el-message{
      min-width: 200px !important;
    }
  }
  .version_pay_box{
    flex-wrap:unset !important;
  }
</style>